/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DeleteItemCommand } from '../../models/delete-item-command';
import { DeleteItemCommandResult } from '../../models/delete-item-command-result';

export interface ApiNurseryManagerItemsDeleteItemDelete$Params {
      body?: DeleteItemCommand
}

export function apiNurseryManagerItemsDeleteItemDelete(http: HttpClient, rootUrl: string, params?: ApiNurseryManagerItemsDeleteItemDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteItemCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiNurseryManagerItemsDeleteItemDelete.PATH, 'delete');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DeleteItemCommandResult>;
    })
  );
}

apiNurseryManagerItemsDeleteItemDelete.PATH = '/api/NurseryManager/Items/DeleteItem';
